import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import Accordion from './FaqAccordion'
import PageSEO from '../shared/PageSEO'
import QnATable from './QnATable'

const Faq = () => {
  const { t } = useTranslation()
  
  return (
    <>
      <PageSEO 
        title="FAQ | Hyunjin Jae"
        description="Frequently asked questions about Hyunjin Jae"
        keywords="faq, frequently asked questions, software development, web technologies, help"
        tags={['faq', 'help', 'questions']}
      />
      <Box sx={{ textAlign: 'center' }}>
        <Accordion />
        <QnATable />
        
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0 }}>
          <Typography
            variant="caption"
            sx={{ fontStyle: 'italic', color: 'text.secondary' }}
          >
            {t('shared:lastUpdated')}: 4/25/2025
          </Typography>
        </Box>
      </Box>
    </>
  )
}

export default Faq